<template>
    
  <div class="builder-header" :class="{ 'border-bottom': canvasMode !== 'history', 'history-mode': canvasMode === 'history' }">
    <div class="container-fluid py-3">
      <PageHeader
          :breadcrumbs="breadcrumbs">

        <template #title>
          <h1>{{ selectedWorkflow.name }}</h1>
        </template>
        <template #actions>
          <button class="bb-btn-primary-cta" @click="createNewWorkflow"><i class="bi bi-plus-lg me-2"></i>New Workflow
          </button>
        </template>
      </PageHeader>

      <!-- Toolbar items — editor mode only. In history mode the RunSummaryHeader
           below the canvas surfaces run details and actions instead. -->
      <div
          v-if="canvasMode !== 'history'"
          class="align-items-center justify-content-between g-3 row"
      >
        <!-- Title -->
        <div class="col-auto">
          <div class="d-flex gap-1">
            <div class="form-floating ">
              <!-- Project select-->
<!--                <select class="form-select form-select-sm" id="project-select">-->
<!--                  <option-->
<!--                      v-for="item in projectsddl"-->
<!--                      :key="item.id"-->
<!--                      :value="item.id"-->
<!--                      :selected="item.id === projectId"-->
<!--                  >-->
<!--                    {{ item.name }}-->
<!--                  </option>-->
<!--                </select>-->
<!--                <label for="project-select">Project</label>-->
            </div>
            <!-- Workflow select-->

            <div class="dropdown" style="position: relative;">
              <button
                  class="bb-btn-secondary-cta btn-sm dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
              >
                {{ selectedWorkflow.name }}
              </button>
              <ul class="dropdown-menu builder-workflow-dropdown">
                <li v-for="workflow in workflowsddl" :key="workflow.id">
                  <a
                      class="dropdown-item d-flex justify-content-between align-items-center"
                      href="#"
                      @click.prevent="selectWorkflow(workflow)"
                  >
                    <span class="flex-grow-1 text-truncate">{{workflow.name}}</span>
                    <i
                        v-if="workflow.id == selectedWorkflowId"
                        class="bi bi-check text-success flex-shrink-0"
                    ></i>
                  </a>
                </li>
                <li><hr class="dropdown-divider" /></li>
                <li>
                  <a
                      class="dropdown-item"
                      href="#"
                      @click.prevent="createNewWorkflow"
                  >
                    <i class="bi bi-plus me-2"></i> Create New Workflow
                  </a>
                </li>
              </ul>
            </div>
            
            <!-- Version Dropdown -->
            <div class="dropdown">
              <button
                  class="bb-btn-secondary-cta btn-sm dropdown-toggle h-100"
                  type="button"
                  data-bs-toggle="dropdown"
              >
                {{ selectedVersionText }}
              </button>
              <ul
                  class="dropdown-menu dropdown-menu-end builder-dropdown-wide builder-version-dropdown"
              >
                <li v-for="version in versions" :key="version.version">
                  <a
                      class="dropdown-item d-flex align-items-start py-2"
                      href="#"
                      @click.prevent="selectVersion(version)"
                  >
                    <!-- Status Icon -->
                    <i
                        class="me-2 mt-1"
                        :class="{
                      'bi bi-pencil text-success': version.status === 'draft',
                      'bi bi-check-circle text-primary': version.status === 'published',
                      'bi bi-eye-slash text-muted': version.status === 'archived',
                    }"
                    ></i>

                    <div class="flex-grow-1">
                      <div
                          class="d-flex align-items-center justify-content-between"
                      >
                        <strong >{{ version.version }}</strong>
                        <small
                            v-if="
                          isPublisherMasterProject && version.subscriberCount
                        "
                            class="text-muted"
                        >
                          {{ version.subscriberCount }} orgs
                        </small>
                      </div>

                      <div class="small text-muted">
                        {{ version.description }}
                      </div>

                      <!-- Product Usage - only show for publisher master projects -->
                      <div
                          v-if="
                        isPublisherMasterProject &&
                        version.usedInProducts?.length
                      "
                          class="small text-info mt-1"
                      >
                        Used in Products {{ version.usedInProducts.join(", ") }}
                      </div>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
<!--            <button class="btn btn-sm btn-tertiary" @click="$emit('executeWorkflow')">-->
<!--              <i class="bi bi-play-fill"></i>Run-->
<!--            </button>-->
            <!-- History Mode Controls (left: version + status badge) -->
            <div
                v-if="canvasMode === 'history' && selectedRun"
                class="d-flex align-items-center gap-2 flex-wrap"
            >
              <span class="badge bb-badge-secondary">{{ selectedVersion }}</span>
              <span class="badge" :class="getRunStatusBadgeClass(selectedRun.status)">
                <span
                    v-if="selectedRun.status === 'Running' || selectedRun.status === 'Pending'"
                    class="spinner-border spinner-border-sm me-1"
                    style="width: 0.7rem; height: 0.7rem"
                    role="status"
                ></span>
                <i
                    v-else
                    class="me-1"
                    :class="{
                      'bi bi-check-circle': selectedRun.status === 'Succeeded',
                      'bi bi-x-circle': selectedRun.status === 'Failed',
                      'bi bi-exclamation-triangle': selectedRun.status === 'Warning',
                    }"
                ></i>
                {{ getRunStatusLabel(selectedRun.status) }}
              </span>
            </div>
          </div>
        </div>
        <!-- Actions -->
        <div class="gap-3 flex-wrap col-auto">
          <!-- Builder Controls -->
          <div class="d-flex flex-wrap gap-1">

            <!-- Actions and Status -->
            <div
                v-if="canvasMode === 'editor'"
                class="d-flex align-items-center gap-3 flex-wrap"
            >
              <div class="d-flex align-items-center gap-2">
                <div class="form-check form-switch mb-0">
                  <input
                      class="form-check-input"
                      type="checkbox"
                      id="activeToggle"
                      :checked="isActive"
                      @change="
                  $emit(
                    'updateIsActive',
                    ($event.target as HTMLInputElement).checked
                  )
                "
                  />
                  <label
                      class="form-check-label fw-medium"
                      for="activeToggle"
                      :class="{ 'text-success': isActive, 'text-muted': !isActive }"
                  >
                    {{ isActive ? "Active" : "Inactive" }}
                  </label>
                </div>
              </div>
              <div class="d-flex align-items-center gap-2">
                <button
                    v-if="!isPublishedVersion"
                    class="bb-btn-secondary-cta btn-sm"
                    @click="openWizardDesigner"
                    title="Design workflow wizard steps"
                >
                  <i class="bi bi-magic me-1"></i>Wizard
                </button>
                <button
                    v-if="!isPublishedVersion"
                    class="bb-btn-tertiary-cta btn-sm"
                    :disabled="!hasDraftChanges"
                    :title="!hasDraftChanges ? 'No draft changes to publish' : ''"
                    @click="publishVersion"
                >
                  <i class="bi me-1" :class="publishActionIcon"></i>{{ publishActionLabel }}
                </button>
                <!-- Actions Menu -->
                <div class="dropdown builder-dropdown-z">
                  <button
                      class="bb-btn-secondary-cta btn-sm"
                      type="button"
                      data-bs-toggle="dropdown"
                      title="More options"
                  >
                    <i class="bi bi-three-dots"></i>
                  </button>
                  <ul class="dropdown-menu dropdown-menu-end">
                    <li>
                      <a
                          class="dropdown-item"
                          href="#"
                          @click.prevent="handleAddServiceFromMenu"
                      ><i class="bi bi-plus-circle me-2"></i> Add Service</a
                      >
                    </li>
                    <li><hr class="dropdown-divider" /></li>
                    <li v-if="!isPublishedVersion">
                      <a
                          class="dropdown-item"
                          :class="{ disabled: !hasDraftChanges }"
                          href="#"
                          :title="!hasDraftChanges ? 'No draft changes to publish' : ''"
                          @click.prevent="hasDraftChanges && publishVersion()"
                      ><i class="bi me-2" :class="publishActionIcon"></i> {{ publishActionLabel }}</a
                      >
                    </li>
                    <li v-if="!isPublishedVersion && hasPublishedVersions">
                      <a
                          class="dropdown-item text-danger"
                          :class="{ disabled: !hasDraftChanges }"
                          href="#"
                          :title="!hasDraftChanges ? 'No unpublished changes to discard' : 'Revert to the last published version'"
                          @click.prevent="hasDraftChanges && discardChanges()"
                      ><i class="bi bi-arrow-counterclockwise me-2"></i> Discard changes</a
                      >
                    </li>
                    <li v-if="isPublishedVersion">
                      <a
                          class="dropdown-item"
                          href="#"
                          @click.prevent="copyVersion"
                      ><i class="bi bi-copy me-2"></i> Use as new draft</a
                      >
                    </li>
                    <li><hr class="dropdown-divider" /></li>
                    <li class="dropdown-submenu">
                      <a
                          class="dropdown-item d-flex justify-content-between align-items-center"
                          href="#"
                          @click.prevent.stop="toggleTestingContextDropdown"
                      >
                    <span
                    ><i class="bi bi-wrench me-2"></i>Testing Context</span
                    >
                        <div class="d-flex align-items-center gap-2">
                          <small class="text-muted ms-2">{{
                              selectedTestingContext
                            }}</small>
                          <i class="bi bi-chevron-right"></i>
                        </div>
                      </a>
                      <ul
                          class="dropdown-menu testing-context-submenu"
                          :class="{ show: showTestingContextDropdown }"
                          @click.stop
                      >
                        <li class="dropdown-header">Select Context</li>
                        <li v-for="context in testingContexts" :key="context.id">
                          <a
                              class="dropdown-item d-flex justify-content-between"
                              href="#"
                              @click.prevent="selectTestingContext(context)"
                          >
                            <span>{{ context.name }}</span>
                            <div class="d-flex align-items-center gap-1">
                          <span
                              v-if="context.type === 'master'"
                              class="badge bg-primary"
                          >Master</span
                          >
                              <span
                                  v-else-if="context.type === 'publisher'"
                                  class="badge bg-info"
                              >Publisher</span
                              >
                              <span
                                  v-else-if="context.type === 'partner'"
                                  class="badge bg-primary"
                              >Partner</span
                              >
                              <i
                                  v-if="context.active"
                                  class="bi bi-check text-success"
                              ></i>
                            </div>
                          </a>
                        </li>
                      </ul>
                    </li>
                    <li><hr class="dropdown-divider" /></li>
                    <li>
                      <span
                          class="dropdown-item disabled d-flex align-items-center"
                          aria-disabled="true"
                          title="Coming soon"
                      ><i class="bi bi-clock-history me-2"></i> View Version History
                        <span class="badge bb-badge-secondary ms-auto">Soon</span></span
                      >
                    </li>
                    <li>
                      <span
                          class="dropdown-item disabled d-flex align-items-center"
                          aria-disabled="true"
                          title="Coming soon"
                      ><i class="bi bi-arrow-left-right me-2"></i> Compare Versions
                        <span class="badge bb-badge-secondary ms-auto">Soon</span></span
                      >
                    </li>
                    <li><hr class="dropdown-divider" /></li>
                    <li>
                      <a
                          class="dropdown-item"
                          href="#"
                          @click.prevent="importWorkflow"
                      ><i class="bi bi-upload me-2"></i> Import</a
                      >
                    </li>
                    <li>
                      <a
                          class="dropdown-item"
                          href="#"
                          @click.prevent="exportWorkflow"
                      ><i class="bi bi-download me-2"></i> Export</a
                      >
                    </li>
                    <li><hr class="dropdown-divider" /></li>
                    <li>
                      <a
                          class="dropdown-item"
                          href="#"
                          @click.prevent="exitBuilder"
                      ><i class="bi bi-box-arrow-left me-2"></i> Back to project</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <!-- History Mode Summary and Actions -->
            <div
                v-if="canvasMode === 'history' && selectedRun"
                class="d-flex align-items-center gap-3"
            >
              <div class="text-muted small">
                <i class="bi bi-clock me-1"></i>{{ formatRunTime(selectedRun.startedAt) }}
                <template v-if="selectedRun.durationInMilliSeconds">
                  &nbsp;•&nbsp;Duration: {{ formatDuration(selectedRun.durationInMilliSeconds) }}
                </template>
              </div>

              <!-- History Mode Actions Menu -->
              <div class="dropdown builder-dropdown-z">
                <button
                    class="bb-btn-secondary-cta btn-sm"
                    type="button"
                    data-bs-toggle="dropdown"
                    title="More options"
                >
                  <i class="bi bi-three-dots"></i>
                </button>
                <ul class="dropdown-menu dropdown-menu-end">
                  <li>
                    <a
                        class="dropdown-item"
                        href="#"
                        @click.prevent="rerunWorkflow"
                    ><i class="bi bi-arrow-clockwise me-2"></i> Re-run</a
                    >
                  </li>
                  <li>
                    <a
                        class="dropdown-item"
                        href="#"
                        @click.prevent="exportRunData"
                    ><i class="bi bi-download me-2"></i> Export Run Data</a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Published Version Info Banner -->
  <div
    v-if="isPublishedVersion && canvasMode !== 'history'"
    class="alert alert-info d-flex align-items-center mb-0 rounded-0 border-0"
    role="alert"
  >
    <i class="bi bi-info-circle me-2"></i>
    <div class="flex-grow-1">
      <strong
        >Viewing Published Read-Only Version {{ selectedVersion }}</strong
      >
      <div
        v-if="isPublisherMasterProject && currentVersionUsage"
        class="small text-muted"
      >
        Used in Products {{ currentVersionUsage.products.join(", ") }} •
        {{ currentVersionUsage.totalSubscribers }} organisations total
      </div>
      <span
        v-else-if="currentVersion?.status === 'published'"
        class="small text-muted"
      >
        {{ currentVersion.description }}
      </span>
    </div>
    <div class="d-flex gap-2">
      <button class="bb-btn-secondary-cta btn-sm" @click="copyVersion">
        <i class="bi bi-clipboard me-1"></i>Use as new draft
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {computed} from "vue";
import PageHeader from "@/components/PageHeader.vue";
import type {RunHistory} from "@/types";
import type {BreadcrumbItem} from "@/components/PageHeader.vue";
import { formatDuration, formatRunTime, getRunStatusBadgeClass, getRunStatusLabel } from "../utils/runFormatters";

const props = defineProps<{
  hasProjectContext: boolean;
  currentProject: any;
  projectId: string;
  canvasMode: string;
  selectedWorkflow: {id:string, name:string};
  workflowsddl:  {id:string, name:string}[];
  projectsddl:  {id:string, name:string}[];
  selectedVersion: string;
  selectedVersionText: string;
  versions: any[];
  isPublisherMasterProject: boolean;
  selectedRun:  RunHistory | null;
  isActive: boolean;
  isPublishedVersion: boolean;
  hasDraftChanges: boolean;
  hasPublishedVersions: boolean;
  showTestingContextDropdown: boolean;
  selectedTestingContext: string;
  testingContexts: any[];
  currentVersionUsage: any;
  currentVersion: any;
}>();

const emit = defineEmits<{
  openProjectPicker: [];
  handleSelectWorkflow: [workflow: any];
  createNewWorkflow: [];
  selectVersion: [version: any];
  handleAddServiceFromMenu: [];
  publishVersion: [];
  discardChanges: [];
  copyVersion: [];
  toggleTestingContextDropdown: [];
  selectTestingContext: [context: any];
  importWorkflow: [];
  exportWorkflow: [];
  rerunWorkflow: [];
  exportRunData: [];
  exitBuilder: [];
  openWizardDesigner: [];
  updateIsActive: [value: boolean];
}>();

const breadcrumbs = computed<BreadcrumbItem[]>(() => {
  const base: BreadcrumbItem[] = [
    { label: 'Dashboard', href: '/' },
    { label: 'Projects', href: '/projects' },
    { label: props.currentProject?.name, href: `/projects/${props.projectId}/workflows` },
    { label: 'Builder', href: `/projects/${props.projectId}/builder` },
    { label: `${props.selectedWorkflow?.name}`, href: `/projects/${props.projectId}/builder/${props.selectedWorkflow.id}/editor` },
  ];

  if (props.canvasMode === 'history') {
    base.push({ label: 'History', href: `/projects/${props.projectId}/builder/${props.selectedWorkflow.id}/history` });
    if (props.selectedRun) {
      base.push({ label: `${props.selectedRun.id}` });
    }
  } else {
    base.push({ label: 'Editor' });
  }

  return base;
});

function selectWorkflow(workflow: any) {
  emit('handleSelectWorkflow', workflow);
}

const selectedWorkflowId = computed(() => props.selectedWorkflow.id);

// "Publish" reads as "make available to others" — that's accurate for a publisher's master,
// but for a subscriber editing their fork it just means "make my edits effective in my project".
// Use "Apply" for the subscriber-fork case to match the actual semantic.
const isSubscriberContext = computed(() => props.currentProject?.projectType === "Subscriber");
const publishActionLabel = computed(() => (isSubscriberContext.value ? "Apply" : "Publish"));
const publishActionIcon = computed(() => (isSubscriberContext.value ? "bi-check2-circle" : "bi-upload"));

function createNewWorkflow() {
  emit("createNewWorkflow");
}

function selectVersion(version: any) {
  emit("selectVersion", version);
}

function publishVersion() {
  emit("publishVersion");
}

function discardChanges() {
  emit("discardChanges");
}

function copyVersion() {
  emit("copyVersion");
}

function toggleTestingContextDropdown() {
  emit("toggleTestingContextDropdown");
}

function selectTestingContext(context: any) {
  emit("selectTestingContext", context);
}

function importWorkflow() {
  emit("importWorkflow");
}

function exportWorkflow() {
  emit("exportWorkflow");
}

function rerunWorkflow() {
  emit("rerunWorkflow");
}

function exportRunData() {
  emit("exportRunData");
}

function exitBuilder() {
  emit("exitBuilder");
}

function handleAddServiceFromMenu() {
  emit("handleAddServiceFromMenu");
}

function openWizardDesigner() {
  emit("openWizardDesigner");
}
</script>

<style scoped lang="scss">


.builder-workflow-dropdown {
  min-width: 300px;
}

//.builder-workflow-dropdown .dropdown-item.d-flex {
//  display: block !important;
//}
//
//.builder-workflow-dropdown .dropdown-item.d-flex span {
//  display: inline !important;
//}

//.builder-workflow-dropdown .dropdown-item.d-flex i {
//  display: inline !important;
//  float: right !important;
//}

.builder-header {
  background-color: var(--bs-body-bg);
}

.builder-header.history-mode {
  // Fixed height only from md up. Below md the title/breadcrumb/actions wrap and
  // would overflow a fixed height (letting the canvas overlap the New Workflow
  // button), so let it size to content on mobile.
  @include media-breakpoint-up(md) {
    height: 102px;
  }
}

.small-badge {
  font-size: 0.875rem;
}

.builder-dropdown-wide {
  min-width: 350px;
}

.builder-dropdown-z {
  position: relative;
  //z-index: 15;
}

.builder-version-dropdown {
  //z-index: 30 !important;
}

.dropdown-submenu {
  position: relative;
}

.testing-context-submenu {
  position: absolute;
  top: 0;
  right: 100%;
  margin-right: 2px;
  min-width: 250px;
  //z-index: 1010 !important;
}

@media (max-width: 768px) {
  .border-bottom .d-flex.justify-content-between {
    flex-direction: column;
    align-items: flex-start !important;
    gap: 1rem;
  }

  .border-bottom .d-flex.justify-content-between nav {
    width: 100%;
  }

  .builder-dropdown-z .dropdown-menu {
    //z-index: 1030 !important;
  }
}
</style>
